/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';
import Filter from './Filter';

import AppContext from '../../AppContext';

const FiltersWrapper = styled(Box, {})(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '10px 0',
}));

const Filters = ({ enteringIndex }) => {
    const { qlikApp } = useContext(AppContext);

    const clearSelection = () => {
        qlikApp.clearAll();
    };

    return (
        <FiltersWrapper>

            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                flexDirection: 'column',
                gap: '10px',
            }}
            >
                <Box>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>FILTER BY:</Typography>
                </Box>
                <Filter field="Respondent Country" />
                <Filter field="Position" />
                <Filter field="Organisation Size" />
                <Filter field="Organisation Sector" />
            </Box>
            <Box sx={{
                marginTop: '10px',
            }}
            >
                <Button variant="outlined" color="error" onClick={() => clearSelection()}>Clear Selections</Button>
            </Box>
        </FiltersWrapper>
    );
};

Filters.propTypes = {
    enteringIndex: PropTypes.number,
};

Filters.defaultProps = {
    enteringIndex: 0,
};

export default Filters;
